module.exports = __webpack_public_path__ + "static/img/main_txt_03.faca9dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main/main_txt_03.png
// module id = 5/OC
// module chunks = 1